import { useState } from "react";
import { FaEdit, FaPlus } from "react-icons/fa";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { useGetRolesList } from "./hook/useSuperSetting";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import RolesModalContent from "../ModalContent/RolesModalContent";

const BranchHqDataColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Role",
    selector: (row: { RoleName: string }) => row.RoleName || "-",
    sortable: true,
    wrap: true,
  },
  {
    name: "Description",
    selector: (row: { RoleDesc: string }) => row.RoleDesc || "-",
    sortable: true,
    wrap: true,
  },
  {
    name: "Private",
    selector: (row: { RolePrivate: boolean }) =>
      row.RolePrivate === false ? "No" : "Yes",
    sortable: true,
    wrap: true,
  },
  {
    name: "Action",
    cell: (row: any) => (
      <button
        onClick={() => handleEdit(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const RolesTable = () => {
  // =============Filter States===========
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });
  // ============== Modal State ==================
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  const { data: rolesListData } = useGetRolesList({
    enable: true,
    params: {
      search: filtersState?.search,
      page: filtersState?.page,
      limit: filtersState?.limit,
    },
  });

  // =======================Table Pagination Functions===================
  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  //===============Modal Edit Function ===============================
  const handleEdit = (row: any) => {
    // console.log("Row Data :::::::::::::", row);
    setIsModalOpen(!isModalOpen);
    setSelectedRow(row);
    setModalStatus("Edit");
  };

  //================== Modal Function==========================
  const toggleModal = () => {
    setIsModalOpen(false);
  };

  const handleAddRoles = (status: string) => {
    setModalStatus(status);
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="container mt-3">
      <BasicDataTable
        Title="Roles List"
        data={rolesListData?.data?.data || []}
        columns={BranchHqDataColumns(handleEdit)}
        search={false}
        headerContent={
          <button
            onClick={() => handleAddRoles("Add")}
            className="btn btn-info"
            style={{
              borderRadius: "20px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaPlus /> <span>Add Role</span>
          </button>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={rolesListData?.data?.pagination?.total || 0}
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={modalStatus === "Add" ? "Add Roles" : "Edit Roles"}
        size="xl"
        content={
          <>
            <RolesModalContent
              setIsModalOpen={setIsModalOpen}
              setSelectedRow={setSelectedRow}
              setModalStatus={setModalStatus}
              selectedRow={selectedRow}
              modalStatus={modalStatus}
            />
          </>
        }
      />
    </div>
  );
};

export default RolesTable;
